import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children?: React.ReactNode;
}

export const PageContentLayoutMobile = (props: Props) => {
    return (
        <S_PageContentLayoutMobile className={props.className}>
            {props.children}
        </S_PageContentLayoutMobile>
    );
};

const S_PageContentLayoutMobile = styled.div`
    padding: 10px 0px 150px 0;
`;
